module.exports = __webpack_public_path__ + "distribution/img/daizhifu.db6e7b6e.png";